import { ContainerStatusEnum, ModeOfExportEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum, IsNotEmpty } from "class-validator";

export class BookContainerDto{
    @ApiProperty()
    referenceNumber:string;
    @ApiProperty()
    expectedDeliveryDate:Date;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty({enum:Object.values(ContainerStatusEnum)})
    @IsNotEmpty()
    @IsEnum(ContainerStatusEnum)
    containerStatus:ContainerStatusEnum;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    containerNumber:string;
    @ApiProperty()
    vesselSchedule:Date;
    @ApiProperty()
    vesselNumber:string;
    @ApiProperty()
    vesselName:string;
    @ApiProperty()
    lineSeal:string;
    @ApiProperty()
    transporter:string;
    @ApiProperty()
    vehicleNumber:string;
    @ApiProperty()
    driverName:string;
    @ApiProperty()
    driverPhoneNumber:string;
    @ApiProperty()
    cha:string;
    @ApiProperty()
    qcReport:string;
    @ApiProperty()
    buyerInspectionReport:string;
    @ApiProperty()
    vesselScheduleApproval:string;
    @ApiProperty()
    temperature:string;
    @ApiProperty()
    scrollNo:string;
    @ApiProperty()
    scrollDate:Date;
    @ApiProperty()
    portCode:string;
    @ApiProperty()
    shippingBillDate:string;
    @ApiProperty()
    shippingBillNo:string;
    @ApiProperty()
    examinationDate:Date;
    @ApiProperty()
    stuffingStartTime:string;
    @ApiProperty()
    stuffingCompletionTime:string;
    @ApiProperty()
    timeTakenForStuffing:string;
    @ApiProperty()
    authorisedBy:number;
    @ApiProperty()
    updatedUser?:string;
    @ApiProperty()
    containerId?:number;
    @ApiProperty()
    scac?:string;
    @ApiProperty()
    containerSize:string;
    @ApiProperty()
    branchCode:string;
    @ApiProperty()
    tempIndicatorNo1:string;
    @ApiProperty()
    tempIndicatorNo2:string;
    @ApiProperty()
    tempIndicatorNo3:string;
    @ApiProperty()
    shippingLiner:string;
    @ApiProperty()
    blNo:string;
    @ApiProperty()
    etd:Date;
    @ApiProperty()
    eta:Date;
    @ApiProperty()
    freightAfterShipment:string;
    @ApiProperty()
    unitId?:number;
    @ApiProperty()
    temperaturee:string;
    @ApiProperty()
    modeOfExport?:ModeOfExportEnum
    @ApiProperty()
    marksAndNo ?:marksAndNoReq[]
    constructor(referenceNumber:string, containerSize:string, expectedDeliveryDate:Date, saleOrderId:number, containerStatus:ContainerStatusEnum, createdUser:string,containerNumber:string, vesselSchedule:Date, vesselNumber:string,vesselName:string, lineSeal:string, transporter:string, vehicleNumber:string, driverName:string, driverPhoneNumber:string, cha:string,qcReport:string,buyerInspectionReport:string,vesselScheduleApproval:string,temperature:string,scrollNo:string,scrollDate:Date,portCode:string, shippingBillDate:string, shippingBillNo:string, examinationDate:Date, stuffingStartTime:string, stuffingCompletionTime:string, timeTakenForStuffing:string,branchCode:string,tempIndicatorNo1:string,tempIndicatorNo2:string,tempIndicatorNo3:string,shippingLiner:string,freightAfterShipment:string,etd:Date,eta:Date, authorisedBy:number, containerId?:number, updatedUser?:string, scac?:string,unitId?:number,modeOfExport?:ModeOfExportEnum,marksAndNo ?:marksAndNoReq[]){
        this.referenceNumber = referenceNumber;
        this.expectedDeliveryDate = expectedDeliveryDate;
        this.saleOrderId = saleOrderId;
        this.containerStatus = containerStatus;
        this.createdUser = createdUser;
        this.containerNumber = containerNumber;
        this.vesselSchedule = vesselSchedule;
        this.vesselNumber = vesselNumber;
        this.vesselName = vesselName;
        this.lineSeal = lineSeal;
        this.transporter = transporter;
        this.vehicleNumber = vehicleNumber;
        this.driverName = driverName;
        this.driverPhoneNumber = driverPhoneNumber;
        this.cha = cha;
        this.qcReport = qcReport;
        this.buyerInspectionReport = buyerInspectionReport;
        this.vesselScheduleApproval = vesselScheduleApproval;
        this.temperature = temperature;
        this.scrollNo = scrollNo;
        this.scrollDate = scrollDate;
        this.portCode = portCode;
        this.shippingBillDate = shippingBillDate;
        this.shippingBillNo = shippingBillNo;
        this.examinationDate = examinationDate;
        this.stuffingStartTime = stuffingStartTime;
        this.stuffingCompletionTime = stuffingCompletionTime;
        this.timeTakenForStuffing = timeTakenForStuffing;
        this.authorisedBy = authorisedBy;
        this.branchCode = branchCode;
        this.tempIndicatorNo1 = tempIndicatorNo1;
        this.tempIndicatorNo2 = tempIndicatorNo2;
        this.tempIndicatorNo3 = tempIndicatorNo3;
        this.shippingLiner = shippingLiner;
        this.etd = etd;
        this.eta = eta;
        this.containerId = containerId;
        this.updatedUser = updatedUser;
        this.scac = scac;
        this.containerSize = containerSize;
        this.freightAfterShipment = freightAfterShipment;
        this.unitId = unitId;
        this.modeOfExport = modeOfExport
        this.marksAndNo = marksAndNo
    }
}
export class marksAndNoReq {
    saleItemId:number
    marksAndNo:string
    constructor(
        saleItemId:number,
    marksAndNo:string
    ){
        this.marksAndNo = marksAndNo
        this.saleItemId =saleItemId
    }
}